<template>
   <vue-final-modal
      v-model="unshareAll" 
      classes="modal-container"
      content-class="unshare-all-modal-content"
      @before-open="beforeOpen()"
      @click-outside="$emit('cancel')"
      >
            <!--
      @click-outside="$emit('cancel')"
            -->
      <button 
         id="prime"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white row row-cols-auto">
         <card-rectangle :rectangleCard="cardType" class="col mt-1"/>
         <div class="col pe-1">Finalización de Intervención Automática</div>
      </span>
      <div class="unshare-all p-0 mt-1 border-top border-bottom">
         <div class="container">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('final').focus()"></div>
            <!--
            <pre>{{ v310Object }}</pre>
                     <h6 class="text-break"><b><div v-html="content.title"></div></b></h6>
            -->
            <div class="bg-light rounded my-2 ttl p-1"
                  :class=" unshareAllOk ? '' : 'text-danger' "
                  >
               <b>{{message}}</b> 
            </div>
         </div>
      </div>
            <div class="row p-0 justify-content-between mx-0">
               <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
               <div class="d-flex justify-content-end pt-2 px-0 col-10">
                  <button type="button" 
                        :tabindex="tabIndexNumber(3)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="doNotClose = true"
                        :disabled="!unshareAllOk"
                        >
                     Finalización Automática
                  </button>
                  <!-- 
                        @click="doUnshareAll()"
                  -->
                  <button type="button" 
                        id="final"
                        :tabindex="tabIndexNumber(4)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('cancel')"
                        >
                     Salir
                  </button>
                  <div :tabindex="tabIndexNumber(5)" onfocus="document.getElementById('prime').focus()"></div>
               </div>
            </div>
   </vue-final-modal>
   <do-not-close  v-if="doNotClose"
      :messages="[
            'No cierre esta pantalla, espere a que vuelva a aparecer la pantalla anterior.',
            'Esto permitirá terminar correctamente esta operación.'
            ]"
      @onOpened="doUnshareAll()"
      />
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed } from 'vue';
import { useStore } from 'vuex'

import WspService from '../workSpace.service';

import UserCircle from '../../../components/UserCircle.vue';
import CardRectangle from './CardRectangle.vue';

import DoNotClose from './form/DoNotClose.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal,
      CardRectangle,
      DoNotClose
   },

   props: {
      cardType: Object,
      contentId: Number
   },

   emits: [ 'cancel', 'update' ],

   setup( props, { emit }) {
   //setup( props ) {
   //setup() {

      const initialTabIndex = ref(150)
      const unshareAll = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const message = ref('Esta operación finaliza de forma automática la intervención de esta tarjeta, desde este tablero hasta el tablero origen.')
      const unshareAllOk = ref(true)
      

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      const doNotClose = ref(false)

      function beforeOpen() {
         
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
      }

      function doUnshareAll() {
         console.log(props.contentId)
         doNotClose.value = true
         WspService.unshareAll( props.contentId, currentUserId.value )
         .then( response => {
         doNotClose.value = false
            if ( response.data ) {
               emit('update')
            } else {
               unshareAllOk.value = false
               message.value = 'Esta operación no se pudo realizar debido a que esta tarjeta se compartió con otro tablero.'
            }
         })
         .catch(error => {
            doNotClose.value = false
            unshareAllOk.value = false
            message.value = 'Esta operación no se pudo realizar debido a un error de sistema o de red.'
            console.log(error);
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         beforeOpen,
         doNotClose, doUnshareAll,
         message, myCircle,
         tabIndexNumber,
         unshareAll, unshareAllOk
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.unshare-all-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 300px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.shunshare-all {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
.ttl {
   color: darkslategray;
}
</style>
